var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { SET_CADUCADO, SET_MENSAJE_CADUCIDAD } from '../actions/index';
export default function caducado() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    caducado: false
  };
  var action = arguments[1];

  switch (action.type) {
    case SET_CADUCADO:
      return _extends({}, state, {
        caducado: action.caducado,
        msg: action.msg
      });

    case SET_MENSAJE_CADUCIDAD:
      return _extends({}, state, {
        msgCaducidad: action.msgCaducidad
      });

    default:
      return state;
  }
}